import React from "react";
import styled from "styled-components";

const Title = styled.hr`
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.5em;
  opacity: 0.5;
  font-size: 12px;
  &:before {
    content: "";
    background: linear-gradient(to right, transparent, #818078, transparent);
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
  }
  &:after {
    content: attr(data-content);
    position: relative;
    display: inline-block;
    color: black;

    padding: 0 0.5em;
    line-height: 1.5em;
    color: #818078;
    background-color: #${props => props.bg};
  }
`;

class HrTitle extends React.Component {
  render() {
    const bg = this.props.bg || "f7f7f7";
    const title = this.props.title || "Title";
    return <Title data-content={title} bg={bg} />;
  }
}

export default HrTitle;
